'use client';

import { PsResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: PsResult;
  translations: ToolsTranslations['ps'];
  pricePerShare: number;
  revenuePerShare: number;
  currency: string;
}

export default function ResultsDisplay({ result, translations, pricePerShare, revenuePerShare, currency }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.psRatio !== null ? `${result.psRatio.toFixed(2)}${translations.ratioSuffix}` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>
      {result.isValid && result.psRatio !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.pricePerShare}:</span>
              <span className="font-medium">{pricePerShare.toLocaleString()} {translations.currencySuffix}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.revenuePerShare}:</span>
              <span className="font-medium">{revenuePerShare.toLocaleString()} {translations.currencySuffix}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.interpretation}:</span>
              <span className="font-medium text-blue-600">{result.interpretation}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


